import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=76f46035&scoped=true&external"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"
import style0 from "./Discounts.vue?vue&type=style&index=0&id=76f46035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f46035",
  null
  
)

export default component.exports